import { render, staticRenderFns } from "./luggage.vue?vue&type=template&id=14ad12ba&"
import script from "./luggage.vue?vue&type=script&lang=js&"
export * from "./luggage.vue?vue&type=script&lang=js&"
import style0 from "./luggage.vue?vue&type=style&index=0&id=14ad12ba&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports